/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __ol__ = _interopDefault(require('openlayers'));
var Vue = _interopDefault(require('vue'));
var imageStyle = _interopDefault(require('../mixin/image-style'));
var withFillStrokeStyle = _interopDefault(require('../mixin/with-fill-stroke-style'));
var minilo = require('../util/minilo');
var mergeDescriptors = _interopDefault(require('../util/multi-merge-descriptors'));
var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));

var Circle = __ol__.style.Circle;
var props = {
  radius: {
    type: Number,
    default: 5
  }
};

var methods = {
  /**
   * @return {ol.style.Circle}
   * @protected
   */
  createStyle: function createStyle() {
    return new Circle({
      radius: this.radius,
      snapToPixel: this.snapToPixel,
      fill: this._fill,
      stroke: this._stroke
    });
  },

  /**
   * @returns {Object}
   * @protected
   */
  getServices: function getServices() {
    var vm = this;

    return mergeDescriptors(imageStyle.methods.getServices.call(this), {
      get stylesContainer() {
        return vm;
      }
    });
  },

  /**
   * @param {ol.style.Fill|Vue|undefined} fill
   * @return {void}
   */
  setFill: function setFill(fill) {
    fill = fill instanceof Vue ? fill.$style : fill;

    if (fill !== this._fill) {
      this._fill = fill;
      this.scheduleRefresh();
    }
  },

  /**
   * @param {ol.style.Stroke|Vue|undefined} stroke
   * @return {void}
   */
  setStroke: function setStroke(stroke) {
    stroke = stroke instanceof Vue ? stroke.$style : stroke;

    if (stroke !== this._stroke) {
      this._stroke = stroke;
      this.scheduleRefresh();
    }
  }
};

var watch = {
  radius: function radius(value) {
    if (this.$style && !minilo.isEqual(value, this.$style.getRadius())) {
      this.scheduleRefresh();
    }
  }
};

var Style = {
  name: 'vl-style-circle',
  mixins: [imageStyle, withFillStrokeStyle],
  props: props,
  methods: methods,
  watch: watch
};

/**
 * @alias module:circle-style
 */
var index = {
  /**
   * @alias module:circle-style/style
   */
  Style: Style,
  /**
   * @param {Vue} Vue
   * @param {VueLayersOptions} [options]
   */
  install: function install(Vue$$1) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    options = minilo.pick(options, 'dataProjection');
    _Object$assign(Style, options);

    Vue$$1.component(Style.name, Style);
  }
};

module.exports = index;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/circle-style/index.js
// module id = 1455
// module chunks = 1